import React, { PureComponent } from "react"
import styled from 'styled-components'
import { formPagePath } from '../utilities/route'
import NavBar from "./navigation/nav-bar"
import NavComparativeReports from './navigation/nav-comparative-reports'
import ComparativeReportPage from '../containers/statistics-page-comparative-report'
import "antd/lib/tree-select/style/css"
import StatisticsPageHero from './ui/statistics-page-hero'
import NavStatistics from './navigation/nav-statistics'
import NavMainAftergameLinks from './navigation/nav-main-aftergame-links'
import { Redirect } from 'react-router-dom'

class StatisticsPageComparativeReports extends PureComponent {

  t = (phrase) => {
    const { useTranslate } = this.props

    return useTranslate(`data_vault.${phrase}`)
  }

  render() {
    const {
      match: {
        params: { surveyId, languageCode },
      },
      questionnaire,
      questionnaire: {
        canViewAfterGame,
        isAfterGameGuest,
        isFinished,
        logo,
        isDialogueActive,
        areProgressReportsActive
      },
      useTranslate,
      crSection,
      onSetCrSection,
      improvementProject
    } = this.props;

    const toStatistics = formPagePath(languageCode, surveyId, 'finish', 'themes');
    const title = useTranslate("data_vault.statistics_page_title");

    // If the user tries to access this page before aftergame we redirect
    if (isFinished && !canViewAfterGame) {
      return <Redirect to={formPagePath(languageCode, surveyId, 'finish', 'themes')} />;
    }

    return (
      <PageContainer className="aftergame-page comparative-reports-page pb-5">
        <StatisticsPageHero>
          <div className="aftergame-page-container">
            <NavBar
              to={isFinished && !canViewAfterGame && toStatistics}
              afterGame
              inverse={true}
              logo={logo}
              canViewAfterGame={canViewAfterGame}
              isAfterGameGuest={isAfterGameGuest}
            >
              {(canViewAfterGame || isAfterGameGuest) &&
                <NavMainAftergameLinks
                  activePage={"statistics"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  isDialogueActive={isDialogueActive}
                  showProgressReports={areProgressReportsActive}
                  improvementProject={improvementProject}
                />
              }
            </NavBar>
          </div>
          <div className="aftergame-page-container">
            <div className="finish-page__intro">
              <h1>{title}</h1>
              <div className="stats-description">
                <p>{useTranslate("data_vault.statistics_page_description")}</p>
              </div>
              <div className="finish-page__intro__nav-holder">
                <NavStatistics
                  activePage={"comparative-reports"}
                  languageCode={languageCode}
                  surveyId={surveyId}
                  useTranslate={useTranslate}
                  questionnaire={questionnaire}
                />
              </div>
            </div>
          </div>
        </StatisticsPageHero>
        <div className="aftergame-page-container statistics-page-content finish-page__stats pb-5">
          <NavContainer>
            <NavComparativeReports
              activePage={crSection}
              useTranslate={useTranslate}
              handleChange={onSetCrSection}
            />
          </NavContainer>
          <ComparativeReportPage {...this.props} />
        </div>
      </PageContainer>
    );
  }
}

export default StatisticsPageComparativeReports

const PageContainer = styled.div`
  min-height: 100vh;
`;

const NavContainer = styled.div`
  margin-bottom: 25px;
`;


// WEBPACK FOOTER //
// ./src/components/statistics-page-comparative-reports.js